export enum EAddressType {
  COMMERCIAL = 0,
  RESIDENTIAL = 1,
  OTHER = 2,
}
